import { boolean, dateTime, defineAction, enumerated, object, string } from '~/prix'
import agentRequestResponseAction from './agentRequestResponse.action.json'

const agentRequestResponseDefinition = defineAction({
  ...agentRequestResponseAction,
  userActivityLog: true,
  input: object({
    agentCpf: string(),
    entrepreneurCpf: string(),
    response: enumerated({
      accepted: 'accepted',
      refused: 'refused',
    }),
  }),
  output: object({
    success: boolean(),
    state: enumerated({
      searchingAgents: 'searching_agents',
      agentAccepted: 'agent_accepted',
      agentArrived: 'agent_arrived',
      inAttendance: 'in_attendance',
      allAgentsRefused: 'all_agents_refused',
      noAgentsAvailable: 'no_agents_available',
      done: 'done',
      canceled: 'canceled',
    }),
    respondedAt: dateTime(),
  }),
})

export default agentRequestResponseDefinition
